// Angular
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
// Components
import { BaseComponent } from "./views/theme/base/base.component";
// Auth
import { AuthGuard } from "./core/auth";

const routes: Routes = [
  { path: "auth", loadChildren: () => import("./views/pages/auth/auth.module").then((m) => m.AuthModule) },
  { path: "error", loadChildren: () => import("./views/pages/error/error.module").then((m) => m.ErrorModule) },
  {
    path: "",
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () => import("./views/pages/dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "aseguradora",
        loadChildren: () => import("./views/modules/aseguradora/aseguradora.module").then((m) => m.AseguradoraModule),
      },
      {
        path: "consolidado",
        loadChildren: () => import("./views/modules/consolidado/consolidado.module").then((m) => m.ConsolidadoModule),
      },
      {
        path: "despacho",
        loadChildren: () => import("./views/modules/despacho/despacho.module").then((m) => m.DespachoModule),
      },
      {
        path: "detalle",
        loadChildren: () => import("./views/modules/detalle/detalle.module").then((m) => m.DetalleModule),
      },
      {
        path: "generadores",
        loadChildren: () => import("./views/modules/generadores/generadores.module").then((m) => m.GeneradoresModule),
      },
      {
        path: "intermediario",
        loadChildren: () => import("./views/modules/intermediario/intermediario.module").then((m) => m.IntermediarioModule),
      },
      {
        path: "parametros",
        loadChildren: () => import("./views/modules/parameters/parameters.module").then((m) => m.ParametersModule),
      },
      {
        path: "poliza",
        loadChildren: () => import("./views/modules/poliza-madre/poliza-madre.module").then((m) => m.PolizaMadreModule),
      },
      {
        path: "vencer",
        loadChildren: () => import("./views/modules/poliza-vencer/poliza-vencer.module").then((m) => m.PolizaVencerModule),
      },
      {
        path: "reportes",
        loadChildren: () => import("./views/modules/reportes/reportes.module").then((m) => m.ReportesModule),
      },
      {
        path: "borradores",
        loadChildren: () => import("./views/modules/borradores/borradores.module").then((m) => m.BorradoresModule),
      },
      {
        path: "reportes-poliza-consolidado",
        loadChildren: () => import("./views/modules/reporte-poliza-consolidado/reportes-poliza-consolidado.module").then((m) => m.ReportesPolizaConsolidadoModule),
      },
      {
        path: "detalle-poliza",
        loadChildren: () => import("./views/modules/detalle-poliza/detalle-poliza.module").then((m) => m.DetallePolizaModule),
      },
      {
        path: "reporte-aseguradora",
        loadChildren: () => import("./views/modules/reporte-aseguradora/reporte-aseguradora.module").then((m) => m.ReporteAseguradoraModule),
      },
      {
        path: "usuario",
        loadChildren: () => import("./views/modules/usuario-final/usuario-final.module").then((m) => m.UsuarioFinalModule),
      },
      { path: "", redirectTo: "dashboard", pathMatch: "full" },
      { path: "**", redirectTo: "dashboard", pathMatch: "full" },
    ],
  },
  { path: "**", redirectTo: "error/403", pathMatch: "full" },
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
